export default "/images/65c7bb213bd927efdc9c0a604fc43af3.png";